import React from 'react'
import {ReportsSelectorGroup} from "../templates/get-templates";

type Props = {
    className?  : string
    group       : ReportsSelectorGroup
    selected?   : boolean
    onClick     : callback
}

export default function MenuItem(props:Props) {

    const onItemClick = () => {
        props.onClick(props.group)
    }

    const iClasses = Classes("item", props.className, {
        'selected': props.selected
    })

    return (
        <div className={iClasses} onClick={onItemClick}>
            <div className="row">
                <div className={Classes("icon", props.group.icon)}/>
                <div className="name">{props.group.title}</div>
            </div>
        </div>
    )
}
